import { useState } from "react";
import { useFormikContext } from "formik";
import InputFormik from "../../../../common/components/form/InputFormik";

import { FaEye, FaEyeSlash } from "react-icons/fa";

type Props = {
  label: string;
  name: string;
  required?: boolean;
};

function InputPasswordWithToggle(props: Props) {
  const [showPassword, setShowPassword] = useState(false);
  const formik = useFormikContext();

  const toggleVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const hasError = !!(formik.touched[props.name] && formik.errors[props.name]);

  return (
    <div className="relative">
      <InputFormik
        label={props.label}
        name={props.name}
        type={showPassword ? "text" : "password"}
        required={props.required}
        className="pr-10"
      />
      <button
        type="button"
        onClick={toggleVisibility}
        className={`absolute inset-y-0 right-0 top-6 flex items-center pr-3 ${
          hasError ? "mt-4" : ""
        } text-gray-500 hover:text-gray-700 focus:outline-none`}
        aria-label={showPassword ? "Esconder senha" : "Mostrar senha"}
      >
        {showPassword ? <FaEyeSlash /> : <FaEye />}
      </button>
    </div>
  );
}

export default InputPasswordWithToggle;
